import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useConfig } from '../context/ConfigContext';

const Speakers = () => {
    const [speakers, setSpeakers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedSpeaker, setSelectedSpeaker] = useState(null);
    const { config } = useConfig();

    useEffect(() => {
        const fetchSpeakers = async () => {
            try {
                const response = await api.get('/speakers?status=active');
                setSpeakers(response.data);
            } catch (error) {
                console.error("Error fetching", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchSpeakers();
    }, []);

    const primaryColor = config?.primaryColor || '#9d4edd';

    // Get background style for modal (same as Layout)
    const bgStyle = config?.backgroundImage
        ? { backgroundImage: `url(${config.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : { backgroundColor: '#1c0042' };

    const pageDesign = config?.pageDesigns?.speakers || {};
    const showTitle = pageDesign.showTitle !== false;
    const pageTitle = pageDesign.title || 'Nuestros Ponentes';
    const pageSubtitle = pageDesign.subtitle || 'Expertos de talla internacional';

    return (
        <div className="animate-fadeIn pb-20 font-['Alliance-Light']">
            {showTitle && (
                <header className="mb-12 text-center">
                    <h1 className="text-4xl font-black text-white tracking-tight uppercase italic">{pageTitle}</h1>
                    <p className="text-white/80 font-medium mt-2 tracking-widest text-xs uppercase">{pageSubtitle}</p>
                    <div className="w-20 h-1 bg-white/20 mx-auto mt-6 rounded-full"></div>
                </header>
            )}

            {isLoading ? (
                <div className="flex justify-center py-20">
                    <div className="w-10 h-10 border-4 border-white/10 border-t-purple-500 rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
                    {speakers.map((s) => (
                        <div 
                            key={s.id} 
                            className="flex flex-col items-center text-center group cursor-pointer"
                            onClick={() => setSelectedSpeaker(s)}
                        >
                            <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-full border-4 border-white/20 overflow-hidden mb-4 transition-all duration-500 group-hover:border-[#9d4edd] group-hover:scale-105 shadow-2xl">
                                <img 
                                    src={s.photo_url || `https://ui-avatars.com/api/?name=${s.name}&background=random`} 
                                    alt={s.name} 
                                    className="w-full h-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0"
                                />
                            </div>
                            <h3 className="text-lg font-['Alliance-SemiBold'] text-white leading-tight uppercase italic tracking-tighter group-hover:text-[#9d4edd] transition-colors">{s.name}</h3>
                            <p className="text-[10px] font-bold mt-1 uppercase tracking-widest text-white/80">{s.profession}</p>
                        </div>
                    ))}
                    {speakers.length === 0 && (
                        <div className="col-span-full text-center py-20 bg-white/5 rounded-[40px] border-2 border-dashed border-white/20 text-white/50 font-black uppercase tracking-widest italic">
                            Próximamente
                        </div>
                    )}
                </div>
            )}

            {/* Speaker Detail Modal */}
            {selectedSpeaker && (
                <div className="fixed inset-0 z-[150] flex items-center justify-center p-4 animate-fadeIn">
                    {/* Backdrop */}
                    <div 
                        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
                        onClick={() => setSelectedSpeaker(null)}
                    ></div>
                    
                    {/* Modal Content */}
                    <div 
                        className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-[50px] border border-white/20 shadow-2xl animate-scaleUp"
                        style={bgStyle}
                    >
                        <button 
                            className="absolute top-6 right-8 text-white/60 hover:text-white text-2xl z-10"
                            onClick={() => setSelectedSpeaker(null)}
                        >
                            ✕
                        </button>
                        
                        <div className="p-10 flex flex-col items-center text-center">
                            <div className="w-48 h-48 rounded-full border-8 border-white/10 overflow-hidden mb-8 shadow-2xl">
                                <img 
                                    src={selectedSpeaker.photo_url || `https://ui-avatars.com/api/?name=${selectedSpeaker.name}&background=random`} 
                                    alt={selectedSpeaker.name} 
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            
                            <h2 className="text-3xl font-['Boehringer'] text-white uppercase italic mb-2">{selectedSpeaker.name}</h2>
                            <p className="text-sm font-bold uppercase tracking-[0.2em] mb-8" style={{ color: primaryColor }}>{selectedSpeaker.profession}</p>
                            
                            <div className="w-16 h-1 bg-white/20 rounded-full mb-8"></div>
                            
                            <div className="text-white leading-relaxed text-sm text-left font-['Alliance-Light'] max-w-lg whitespace-pre-wrap">
                                {selectedSpeaker.profile || "Sin biografía disponible."}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Speakers;
